// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  openai: true,
  mapskey: 'AIzaSyDf17z4PXbFnZ0awQktR4dGEf7wJ_xGNDk',
  backendurl: "https://trmsdevapi.webbtree.com",//"http://13.233.123.33:3000",
  frontendurl:'https://trmsdev.webbtree.com',
  googleOauthClientId: '347164799773-447b7lrqiru3qslv7j4039amg0d08hcf.apps.googleusercontent.com',
  linkedinurlredirect: "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77abimk9bgnsgz&redirect_uri=",
  webbtreeWebsiteUrl: "https://websitedev.whitecrowresearch.com",
  reCaptchaKey:'6LeWHDMeAAAAAOyPY5C7O6K26gLAVzeXw4RBiWyC',
  aegisFrontendUrl: 'https://devaegis.whitecrowresearch.com',
  aegisClientId: "jk39vupqasdrhpx3c5luq30hwciqi93z",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
